export class DataModelUtils {
    public static getId(prop: string | { _id?: string }): string {
        if (!prop) return;
        if (typeof prop === 'string') return prop;
        return prop._id;
    }
}
